import updateOrderAction from "./updateOrderAction";
import getSurchargedCartAction from "./getSurchargedCartAction";

const setPaymentTypeAction = async (get, session, selected) => {

    const current = get().order?.PaymentRule?.id;
    const returnVal = {};

    const currentInput = get().input || {};
    const input = { ...currentInput, paymentRule: selected }

    if(selected !== current) {
        input.card = undefined;
        await updateOrderAction(session, get, 'PaymentRule', selected);
        const refreshedOrder = await getSurchargedCartAction(session, false, get);
        for(const k of Object.keys(refreshedOrder)) {
            returnVal[k] = refreshedOrder[k];
        }
    }

    return {...returnVal, input};
}

export default setPaymentTypeAction;